import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./en-US.json";
import frFR from "./fr-FR.json";
import deDE from "./de-DE.json";
import esES from "./es-ES.json";
import ptPT from "./pt-PT.json";
import zhHANS from "./zh-HANS.json";
import zhHANT from "./zh-HANT.json";

const LangResources = {
  en: {
    player: enUS,
  },
  fr: {
    player: frFR,
  },
  de: {
    player: deDE,
  },
  es: {
    player: esES,
  },
  pt: {
    player: ptPT,
  },
  "zh-TW": {
    player: zhHANT,
  },
  "zh-HK": {
    player: zhHANT,
  },
  "zh-HANT": {
    player: zhHANT,
  },
  "zh-CN": {
    player: zhHANS,
  },
  "zh-SG": {
    player: zhHANS,
  },
  "zh-HANS": {
    player: zhHANS,
  },
};

export const configureI18N = (locale: string) => {
  let lng = locale;
  if (lng) {
    lng = lng.replace("_", "-");
  }
  const instance = i18n.use(initReactI18next).createInstance(
    {
      // your settings here
      fallbackLng: "en",
      ns: ["player"],
      defaultNS: "player",
      debug: false,
      lng,
      resources: LangResources,
      interpolation: {
        escapeValue: false, // not needed for react!!
      },
    }, // We must provide a function as second parameter, otherwise i18next errors
    (err, t) => {
      if (err) return console.log(err);
    },
  );
  return instance;
};
